import { SendcloudRegion } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";

export const SendcloudCarrierInput = groupInput({
  region: input<SendcloudRegion>({ validator: nonEmptyValidator }),
  publicKey: input<string>({ validator: nonEmptyValidator }),
  secretKey: input<string>({ validator: nonEmptyValidator }),
});

export type SendcloudCarrierValue = InputSchema.Value<
  typeof SendcloudCarrierInput
>;

export type SendcloudCarrierForm = InputSchema.Input<
  typeof SendcloudCarrierInput
>;

export const SendcloudCarrierDefault = (): SendcloudCarrierValue => ({
  region: SendcloudRegion.EU,
  publicKey: "",
  secretKey: "",
});

const REGION_OPTIONS: RedoListItem<SendcloudRegion>[] = [
  { id: "eu", type: "text", text: "EU", value: SendcloudRegion.EU },
  { id: "uk", type: "text", text: "UK", value: SendcloudRegion.UK },
];

export const CreateSendcloudCarrierForm = memo(
  function CreateSendcloudCarrierForm({
    carrierInput,
  }: {
    carrierInput: SendcloudCarrierForm;
  }) {
    return (
      <>
        <RedoSingleSelectDropdownInput
          label="Region"
          options={REGION_OPTIONS}
          optionSelected={({ item }) => {
            carrierInput.inputs.region.setValue(item.value);
          }}
          selectedItem={REGION_OPTIONS.find(
            (option) => option.value === carrierInput.inputs.region.value,
          )}
        />
        <RedoTextInput
          label="Public API key"
          placeholder=""
          setValue={carrierInput.inputs.publicKey.setValue}
          value={carrierInput.inputs.publicKey.value}
        />
        <RedoTextInput
          inputTypeHint="password"
          label="Secret API key"
          placeholder=""
          setValue={carrierInput.inputs.secretKey.setValue}
          value={carrierInput.inputs.secretKey.value}
        />
      </>
    );
  },
);
